import { render, staticRenderFns } from "./PageLogo.vue?vue&type=template&id=fad17c70&scoped=true"
import script from "./PageLogo.vue?vue&type=script&lang=js"
export * from "./PageLogo.vue?vue&type=script&lang=js"
import style0 from "./PageLogo.vue?vue&type=style&index=0&id=fad17c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad17c70",
  null
  
)

export default component.exports